import deleteFilter from '../../rest/delete-filter/index.tsx';

const deleteFilterService = (filterId: string): Promise<void> => deleteFilter(filterId);

export default deleteFilterService;
